import { motion } from 'framer-motion';
import { Heart, Leaf, Award } from 'lucide-react';

export const About = () => {
  const features = [
    {
      icon: Heart,
      title: 'Made with Love',
      description: 'Every batch is handcrafted with care.',
    },
  ];

  return (
    <section id="about" className="py-24 bg-[#EAE3D9]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Meet Kristin Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20">
          {/* Kristin's Photo */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative flex justify-center"
          >
            <div className="relative overflow-hidden rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_spice-ball-bakery/artifacts/gqq1uben_IMG_20260412_163320.jpg"
                alt="Kristin, founder of The Apron, LLC"
                className="w-full max-w-md h-[500px] object-cover object-top"
                data-testid="kristin-photo"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#7B3E19]/10 rounded-sm -z-10"></div>
          </motion.div>

          {/* Kristin's Story */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-sm uppercase tracking-[0.2em] text-[#786C65] mb-4">
              My Story
            </p>
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-[#2A1A14] mb-6" data-testid="about-title">
              My Story
            </h2>
            <div className="space-y-4 text-[#2A1A14]/80 leading-relaxed">
              <p>
                Welcome to The Apron! I'm Kristin, dba The Apron, LLC. I was born and raised in Buffalo, NY. The Sicilian American women in my family always made these delicious cookies during the holiday season and there is something about the blend of clove, cinnamon and cocoa on a cold winter's day. Well, just one issue; I recently moved to Arizona, and I don't experience the winters I used to. I was missing Mom and missing home one day. I wondered how people in my community would like these and I sure wanted to taste them again. So, I called Mom up and got the recipe and...they were a hit!
              </p>
            </div>
          </motion.div>
        </div>

        {/* Kristin and her Mom Photo */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center mb-20"
        >
          <div className="relative rounded-sm overflow-hidden" style={{ width: '400px', maxWidth: '100%', aspectRatio: '3/4' }}>
            <img
              src="https://customer-assets-0z36b82j.emergentagent.net/job_spice-ball-bakery/artifacts/uwy0msvi_IMG_20260515_182550965_HDR.webp"
              alt="Kristin and her Mom"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ transform: 'rotate(90deg) scale(1.35)', transformOrigin: 'center center' }}
              data-testid="kristin-mom-photo"
            />
          </div>
          <p className="text-[#2A1A14] font-heading text-lg font-medium mt-4">
            Kristin and her Mom
          </p>
        </motion.div>

        {/* Features */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 bg-[#7B3E19]/10 rounded-full mb-3">
                <feature.icon className="w-6 h-6 text-[#7B3E19]" />
              </div>
              <h3 className="font-heading font-semibold text-[#2A1A14] mb-1">
                {feature.title}
              </h3>
              <p className="text-sm text-[#786C65]">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
